import mdiVue from 'mdi-vue/v3'
import { mdiMenu, mdiClose } from '@mdi/js'
// https://materialdesignicons.com/
export default app => {
  app.use(mdiVue, {
    icons: { mdiMenu, mdiClose }
  })
}
